import styled from "styled-components";
import { SketchPicker } from "react-color";

interface IColorProps {
  color: string;
}

export const STWrapper = styled.div`
  position: relative;
  width: 100%;

  margin-top: 15px;
`;

export const STColorShape = styled.div`
  position: absolute;
  width: 70%;
  height: 65%;
  bottom: 0;
  right: 0;
  border-radius: 3px;

  background-color: ${(props: IColorProps) => props.color || "#fffff"};
`;

export const STPicker = styled(SketchPicker)`
  && {
    position: absolute;
    z-index: 2;
    touch-action: none;
  }
`;
